// takes the DR settings API response and returns an array of deal types supported by the dealer
const getDealerSupportedDealTypes = function () {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let type = arguments.length > 1 ? arguments[1] : undefined;
  let listing = arguments.length > 2 ? arguments[2] : undefined;
  let listingPrice = arguments.length > 3 ? arguments[3] : undefined;
  const {
    products = {},
    financing = {}
  } = settings;
  const {
    mileage,
    year
  } = listing;
  const {
    hasLeasing
  } = products;
  const {
    limits: {
      mileage: mileageLimit,
      price: priceLimit,
      year: yearMaxLimit
    } = {}
  } = financing;
  const hasCashOffer = settings?.products[`has${type}CashOffer`];
  const vehicleAge = new Date().getFullYear() - year;

  // Inorder to enable finance offer, vehicle mileage < mileage limit and listing price > price limit and vehicle age < year max limit
  const hasFinanceOffer = mileage < mileageLimit && listingPrice > priceLimit && vehicleAge < yearMaxLimit;
  return [hasFinanceOffer && 'finance', hasLeasing && type === 'New' && 'lease', hasCashOffer && 'cash'].filter(Boolean); // removes any false or undefined values from the array
};
export { getDealerSupportedDealTypes as default };
